import React from 'react';
import moment from "moment";
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Pay/Day', value: data.payperday },
        { label: 'Advance', value: data.advance },
        { label: 'Joining Date', value: moment(data.joiningDate).format("DD-MM-YYYY") },
        ...(data.leavingDate ? [{ label: 'Leaving Date', value: moment(data.leavingDate).format("DD-MM-YYYY") }] : []),
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.name}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
